module.exports = __webpack_public_path__ + "static/media/img_dance15.785eb585.png";